// src/components/PrivateRoute.js

import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = () => {
  // Utilisez useContext pour accéder à l'état de l'utilisateur
  const { user, loading } = useContext(AuthContext);

  // Si le chargement est en cours, vous pouvez afficher un spinner
  if (loading) {
    return <div style={{ marginTop: "100px", textAlign: "center" }}> Chargement... </div>;
  }

  // Si l'utilisateur est connecté, le composant `Outlet`
  // rendra le composant enfant de la route.
  // Sinon, il redirige l'utilisateur vers la page de connexion.
  return user ? <Outlet /> : <Navigate to="/authentication/sign-in" />;
};

export default PrivateRoute;
